import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";

// 手続履歴一覧参照API
// API仕様書_申請情報
import {
  IAPI_APP001_Request,
  IAPI_APP001_Response,
} from "../../../type/apiType";

// 手続履歴状態更新API
// API仕様書_申請情報
import {
  IAPI_APP002_Request,
  IAPI_APP002_Response,
} from "../../../type/apiType";

// 手続履歴一覧参照API
// API仕様書_申請情報
const httpAPI_APP001 = async (
  param: IAPI_APP001_Request
): Promise<IAPI_APP001_Response> => {
  let res = await http.post(ApiUrl.API_APP001, {
    ...param,
  });
  return res.data;
};

// 手続履歴状態更新API
// API仕様書_申請情報
const httpAPI_APP002 = async (
  param: IAPI_APP002_Request
): Promise<IAPI_APP002_Response> => {
  let res = await http.post(ApiUrl.API_APP002, {
    ...param,
  });
  return res.data;
};

export { httpAPI_APP001, httpAPI_APP002 };
